import { clsx, type ClassValue } from "clsx"
import { format } from "date-fns"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// check if the value is not undefined or null or empty string or 'null' or 'undefined
export function isDefined(value: any) {
  return (
    value !== undefined &&
    value !== null &&
    value !== "" &&
    value !== "null" &&
    value !== "undefined"
  )
}

// Format a date using date-fns
export function formatDate(
  date: Date | string | null,
  formatString: string = "PPP"
) {
  if (!date) return ""
  return format(new Date(date), formatString)
}
